const breakpoints = {
  Mobile: 320,
  Tablet: 768,
  Desktop: 1024,
  XLDesktop: 1440,
} as const;

export default breakpoints;
